import { render, staticRenderFns } from "./PurchasesOrderListTable.vue?vue&type=template&id=52566f31"
import script from "./PurchasesOrderListTable.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports